import { h, JSX } from 'preact';
import ObservingComponent from '../componentBases/observingComponent';
import { MeetingNotesReportEmailModal as FrontEndMeetingNotesReportEmailModal } from 'core.frontend';
import Button from '../buttons/button';
import Modal from '../containers/modal';
import ButtonColors from '../buttons/buttonColors';
import Alert from '../alerts/alert';
import RichTextField from '../fields/richTextField';
import Field from '../fields/field';

export interface MeetingNotesReportEmailModalProps {
    modal: FrontEndMeetingNotesReportEmailModal;
}

class MeetingNotesReportEmailModal extends ObservingComponent<MeetingNotesReportEmailModalProps> {

    public componentWillMount() {
        this.registerUpdateObserver(this.props.modal.observationProvider);
    }

    public render({ modal }: MeetingNotesReportEmailModalProps): JSX.Element {
        return (
            <div>
                {!!modal.isOpen &&
                    <Modal
                        heading={modal.title}
                        close={modal.hide}
                        headerButtons={[]}
                        footerLeftButtons={[]}
                        footerRightButtons={[
                            <Button
                                color={ButtonColors.Secondary}
                                button={modal.closeButton} />,
                            <Button
                                color={ButtonColors.Primary}
                                button={modal.sendButton} />
                        ]}>

                        <div>
                            <Alert
                                className="mt-1"
                                alert={modal.alert} />


                            <div className="form-container">
                                
                                <Field field={modal.recipientsField} />
                                <Field field={modal.ccEmailField} />
                            
                                <div class="flex mt-1">
                                    <Field
                                        className="v-center mr-1 fill"
                                        field={modal.subjectField} />
                                </div>

                                <RichTextField field={modal.emailTemplateField} />
                            </div>
                        </div>
                    </Modal>
                }
            </div>
        );
    }
}

export default MeetingNotesReportEmailModal;
